import { User } from '@elio/emanager-front/auth/model';
import { Headquarter, Offer } from '@elio/emanager-front/offer/model';
import { Topic } from './messaging-subscription.service';

export const createUserTopic = (user: User): Topic => ({ type: 'USER', entityId: user.id });
export const createOfferTopic = (offer: Offer): Topic => ({ type: 'OFFER', entityId: offer.id });
export const createHeadquarterTopic = (headquarter: Headquarter): Topic => ({
  type: 'HEADQUARTER',
  entityId: headquarter.id,
});

export const topicId = (topic: Topic): string => {
  return topic.type + '~' + topic.entityId;
};
